/*!

=========================================================
* Vision UI Free React - v1.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/vision-ui-free-react
* Copyright 2021 Creative Tim (https://www.creative-tim.com/)
* Licensed under MIT (https://github.com/creativetimofficial/vision-ui-free-react/blob/master LICENSE.md)

* Design and Coded by Simmmple & Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/

// @mui material components
import Card from "@mui/material/Card";

// Vision UI Dashboard React components
import Grid from "@mui/material/Grid";
import Icon from "@mui/material/Icon";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import VuiBox from "components/VuiBox";
import VuiInput from "components/VuiInput";
import VuiTypography from "components/VuiTypography";

// Vision UI Dashboard React example components
import LineChart from "examples/Charts/LineCharts/LineChart2";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import TableFixed from "examples/Tables/TableFixed";

import React, { useEffect, useState, useCallback } from "react"

import { useHistory } from 'react-router-dom';
import { getUser } from 'discordAPI'
import { getAPIToken, getGuilds, getAllMembers } from 'GaiaAPI'
import { getDetailsFromHistoryCode, getDetailsFromHistoryCodeForGuild, getValueFromString } from 'Utils'

function Compare() {
    const history = useHistory();
    const [guilds, setGuilds] = useState([]);
    const [sortMode, setSortMode] = useState(['Power']);

    var allGuilds;
    var allMembers;
    var columnList;
    const [resultColumnsList, setResultColumnsList] = useState([]);

    const [originalMemberRows, setOriginalMemberRows] = useState([]);

    const [memberRows, setMemberRows] = useState([]);
    const [guildRows, setGuildRows] = useState([]);
    const [resultColumns, setResultColumns] = useState([]);
    const [resultRows, setResultRows] = useState([]);
    const [selectedItems, setSelectedItems] = useState([]);

    const [lineChartData, setLineChartData] = useState([]);
    const [lineChartOptions, setLineChartOptions] = useState([]);

    const [menu, setMenu] = useState(null);

    const openMenu = ({ currentTarget }) => setMenu(currentTarget);
    const closeMenu = () => setMenu(null);
    const sortbyPower = () => {
        let newSortMode = 'Power'
        setSortMode(newSortMode);
        refreshResults(selectedItems, newSortMode);
        setMenu(null)
    };
    const sortbySE = () => {
        let newSortMode = 'Star Expedition'
        setSortMode(newSortMode);
        refreshResults(selectedItems, newSortMode);
        setMenu(null)
    };
    const sortbyCCL = () => {
        let newSortMode = 'CCL'
        setSortMode(newSortMode);
        refreshResults(selectedItems, newSortMode);
        setMenu(null)
    };

    const updateSearch = (searchedVal) => {
        try {
            const filteredRows = originalMemberRows.filter((row) => {
                return row.actualname.toLowerCase().includes(searchedVal.toLowerCase());
            });
            setMemberRows(filteredRows.slice(0, 50));
        }
        catch (error) {
            alert(error);
        }
    };

    const renderMenu = (
        <Menu
            id="simple-menu"
            anchorEl={menu}
            anchorOrigin={{
                vertical: "top",
                horizontal: "left",
            }}
            transformOrigin={{
                vertical: "top",
                horizontal: "right",
            }}
            open={Boolean(menu)}
            onClose={closeMenu}
        >
            <MenuItem onClick={sortbyPower}>Power</MenuItem>
            <MenuItem onClick={sortbySE}>Star Expedition</MenuItem>
            <MenuItem onClick={sortbyCCL}>CCL</MenuItem>
        </Menu>
    );

    const memberColumns = [
        { name: "name", align: "left" },
        { name: "guild", align: "left" }
    ]

    const guildColumns = [
        { name: "name", align: "left" }
    ]

    function addItemToResults(item) {
        let mySelectedItems = selectedItems;

        if (!mySelectedItems)
            mySelectedItems = [];

        let index = mySelectedItems.indexOf(item);
        if (index !== -1) {
            mySelectedItems.splice(index, 1);
        }
        else {
            // Block if already 10 shown
            if (mySelectedItems.length >= 10)
                return;

            mySelectedItems.push(item);
        }

        setSelectedItems(mySelectedItems);

        refreshResults(selectedItems, sortMode);
    }

    function getValueFromHistory(history, currentSortMode, isGuild) {
        let result = null;
        var historyCode;

        if (isGuild) 
            historyCode = getDetailsFromHistoryCodeForGuild(history);
        else
            historyCode = getDetailsFromHistoryCode(history);

        if (historyCode) {
            if (currentSortMode === 'Star Expedition')
                result = getValueFromString(historyCode.se);
            else if (currentSortMode === 'CCL')
                result = getValueFromString(historyCode.ccl);
            else {
                result = getValueFromString(historyCode.power);
                if (result && isGuild)
                    result = result * 1000;
            }

            if (isGuild && result && (currentSortMode !== 'CCL')) {
                result = result / 30;
            }

            if (result)
                result = result.toFixed(2);
        }

        return result;
    }

    function adjust(color, amount) {
        return '#' + color.replace(/^#/, '').replace(/../g, color => ('0' + Math.min(255, Math.max(0, parseInt(color, 16) + amount)).toString(16)).substr(-2));
    }

    function refreshResults(mySelectedItems, currentSortMode) {
        try {

            let rows = [];
            let chartRows = [];
            let colours = [];


            let monthColumns = resultColumnsList;
            if (!monthColumns || monthColumns.length === 0)
                monthColumns = columnList;

            for (let i = 0; i < mySelectedItems.length; i++) {
                let values = [];
                let item = mySelectedItems[i]
                let colour = "transparent";
                let membername = null;
                let guildname = null;
                let isGuild = false;
                if (item.guild) {
                    // a member
                    guildname = item.guild;
                    membername = item.name;
                    let myGuilds = guilds;
                    if (!myGuilds || myGuilds.length === 0)
                        myGuilds = allGuilds;

                    let guild = myGuilds.find(item => item.name === guildname);
                    if (guild && guild.colour) {
                        colour = convertHexToRGBA(guild.colour, 0.2);
                        let newColour = adjust('#' + guild.colour, -40);

                        while (colours.includes(newColour) && newColour != '#' + guild.colour) {
                            let prevCol = newColour;
                            newColour = adjust(newColour, -20);
                            if (prevCol === newColour) {
                                newColour = '#' + guild.colour;
                            }
                        }
                        if (newColour === '#' + guild.colour) {
                            newColour = adjust(newColour, +20);
                            while (colours.includes(newColour) && newColour != '#' + guild.colour) {
                                let prevCol = newColour;
                                newColour = adjust(newColour, +20);
                                if (prevCol === newColour) {
                                    newColour = '#' + guild.colour;
                                }
                            }
                        }

                        colours.push(newColour);
                    }
                }
                else {
                    isGuild = true;
                    guildname = item.name;
                    colour = convertHexToRGBA(item.colour, 0.2);
                    colours.push('#' + item.colour);
                }

                values.push(getValueFromHistory(item.history[10], currentSortMode, isGuild));
                values.push(getValueFromHistory(item.history[9], currentSortMode, isGuild));
                values.push(getValueFromHistory(item.history[8], currentSortMode, isGuild));
                values.push(getValueFromHistory(item.history[7], currentSortMode, isGuild));
                values.push(getValueFromHistory(item.history[6], currentSortMode, isGuild));
                values.push(getValueFromHistory(item.history[5], currentSortMode, isGuild));
                values.push(getValueFromHistory(item.history[4], currentSortMode, isGuild));
                values.push(getValueFromHistory(item.history[3], currentSortMode, isGuild));
                values.push(getValueFromHistory(item.history[2], currentSortMode, isGuild));
                values.push(getValueFromHistory(item.history[1], currentSortMode, isGuild));
                values.push(getValueFromHistory(item.history[0], currentSortMode, isGuild));
                 
                if (currentSortMode === 'Star Expedition') {
                    let result = 0;
                    if (isGuild) {
                        result = getValueFromString(item.seScore);
                        if (result && isGuild)
                            result = result / 30;
                    }
                    else
                        result = getValueFromString(item.se);
                    if (!result)
                        result = 0;
                    values.push(result.toFixed(2));
                }
                else if (currentSortMode === 'CCL') {
                    let result = 0;
                    if (isGuild)
                        result = getValueFromString(item.avgCCL);
                    else
                        result = getValueFromString(item.ccl);
                    if (!result)
                        result = 0;
                    values.push(result.toFixed(2));
                }
                else {
                    let result = getValueFromString(item.power);
                    if (result && isGuild)
                        result = (result * 1000) / 30;
                    if (!result)
                        result = 0;
                    values.push(result.toFixed(2));
                }

                let row = {
                    name:
                        <VuiBox display="flex" alignItems="center" px={0.8} py={0.1}>
                            <VuiBox display="flex" flexDirection="column">
                                <VuiTypography variant="button" color="white" fontWeight="medium">
                                    {membername}
                                </VuiTypography>
                            </VuiBox>
                        </VuiBox>,
                    guild:
                        <VuiBox display="flex" alignItems="center" bgColor={colour} sx={{ width: '100px', borderRadius: '12px' }}>
                            <VuiBox display="flex" alignItems="center" flexDirection="column">
                                <VuiTypography pl="10px" variant="button" color="white" fontWeight="medium" >
                                    {guildname}
                                </VuiTypography>
                            </VuiBox>
                        </VuiBox>,
                    [monthColumns[0]]:
                        <VuiBox display="flex" alignItems="center" px={0.8} py={0.1}> <VuiTypography variant="button" color="white" fontWeight="medium"> {values[0]} </VuiTypography></VuiBox>,
                    [monthColumns[1]]:
                        <VuiBox display="flex" alignItems="center" px={0.8} py={0.1}> <VuiTypography variant="button" color="white" fontWeight="medium"> {values[1]} </VuiTypography></VuiBox>,
                    [monthColumns[2]]:
                        <VuiBox display="flex" alignItems="center" px={0.8} py={0.1}> <VuiTypography variant="button" color="white" fontWeight="medium"> {values[2]} </VuiTypography></VuiBox>,
                    [monthColumns[3]]:
                        <VuiBox display="flex" alignItems="center" px={0.8} py={0.1}> <VuiTypography variant="button" color="white" fontWeight="medium"> {values[3]} </VuiTypography></VuiBox>,
                    [monthColumns[4]]:
                        <VuiBox display="flex" alignItems="center" px={0.8} py={0.1}> <VuiTypography variant="button" color="white" fontWeight="medium"> {values[4]} </VuiTypography></VuiBox>,
                    [monthColumns[5]]:
                        <VuiBox display="flex" alignItems="center" px={0.8} py={0.1}> <VuiTypography variant="button" color="white" fontWeight="medium"> {values[5]} </VuiTypography></VuiBox>,
                    [monthColumns[6]]:
                        <VuiBox display="flex" alignItems="center" px={0.8} py={0.1}> <VuiTypography variant="button" color="white" fontWeight="medium"> {values[6]} </VuiTypography></VuiBox>,
                    [monthColumns[7]]:
                        <VuiBox display="flex" alignItems="center" px={0.8} py={0.1}> <VuiTypography variant="button" color="white" fontWeight="medium"> {values[7]} </VuiTypography></VuiBox>,
                    [monthColumns[8]]:
                        <VuiBox display="flex" alignItems="center" px={0.8} py={0.1}> <VuiTypography variant="button" color="white" fontWeight="medium"> {values[8]} </VuiTypography></VuiBox>,
                    [monthColumns[9]]:
                        <VuiBox display="flex" alignItems="center" px={0.8} py={0.1}> <VuiTypography variant="button" color="white" fontWeight="medium"> {values[9]} </VuiTypography></VuiBox>,
                    [monthColumns[10]]:
                        <VuiBox display="flex" alignItems="center" px={0.8} py={0.1}> <VuiTypography variant="button" color="white" fontWeight="medium"> {values[10]} </VuiTypography></VuiBox>,
                    [monthColumns[11]]:
                        <VuiBox display="flex" alignItems="center" px={0.8} py={0.1}> <VuiTypography variant="button" color="white" fontWeight="medium"> {values[11]} </VuiTypography></VuiBox>,
                    [monthColumns[12]]:
                        <VuiBox display="flex" alignItems="center" px={0.8} py={0.1}> <VuiTypography variant="button" color="white" fontWeight="medium"> {values[12]} </VuiTypography></VuiBox>
                };

                rows.push(row);

                let chartname = membername;
                if (isGuild)
                    chartname = guildname;
                chartRows.push({
                    name: chartname,
                    data: values
                });
            }

            setResultRows(rows);
            setupLineChart(chartRows, colours, monthColumns);
        }
        catch (error) {
            alert(error);
        }
    }


    function setupLineChart(rows, colours, months) {
        let options = {
            chart: {
                toolbar: {
                    show: false,
                },
            },
            tooltip: {
                theme: "dark",
            },
            dataLabels: {
                enabled: false,
            },
            stroke: {
                curve: "smooth",
            },
            xaxis: {
                type: "datetime",
                categories: months,
                labels: {
                    style: {
                        colors: "#c8cfca",
                        fontSize: "10px",
                    },
                },
                axisBorder: {
                    show: false,
                },
                axisTicks: {
                    show: false,
                },
            },
            yaxis: {
                labels: {
                    style: {
                        colors: "#c8cfca",
                        fontSize: "10px",
                    },
                },
            },
            legend: {
                show: false,
            },
            grid: {
                strokeDashArray: 5,
                borderColor: "#56577A",
            },
            fill: {
                type: "gradient",
                gradient: {
                    shade: "dark",
                    type: "vertical",
                    shadeIntensity: 0,
                    gradientToColors: undefined, // optional, if not defined - uses the shades of same color in series
                    inverseColors: true,
                    opacityFrom: 0.8,
                    opacityTo: 0,
                    stops: [],
                },
                colors: colours,
            },
            colors: colours, //["#0075FF", "#2CD9FF"],
        }

        setLineChartOptions(options);
        setLineChartData(rows);
    }

    const onSelectItem = (member, guild) => {
        if (member && guild) {
            try {
                let memberToAdd = allMembers.find(item => item.name === member && item.guild === guild);
                if (memberToAdd)
                    addItemToResults(memberToAdd);
            }
            catch (error) {
                alert(error);
            }
        }
        else if (guild) {
            try {
                let guildToAdd = allGuilds.find(item => item.name === guild);
                if (guildToAdd)
                    addItemToResults(guildToAdd);
            }
            catch (error) {
                alert(error);
            }
        }
    }

    function convertHexToRGBA(hex, opacity) {
        const tempHex = hex.replace('#', '');
        const r = parseInt(tempHex.substring(0, 2), 16);
        const g = parseInt(tempHex.substring(2, 4), 16);
        const b = parseInt(tempHex.substring(4, 6), 16);

        return 'rgba(' + r + ',' + g + ',' + b + ',' + opacity + ')';
    };

    function setResultsColumns(guilds) {
        if (guilds.length > 0) {
            let columns = [];
            let myresultColumnsList = [];
            let guild = guilds[0];

            columns.push({ name: "name", align: "left" });
            columns.push({ name: "guild", align: "left" });

            for (let i2 = 11 - 1; i2 >= 0; i2--) {
                columns.push({ name: guild.historyDates[i2], align: "left" });
                myresultColumnsList.push(guild.historyDates[i2]);
            }
            columns.push({ name: 'Now', align: "left" });
            myresultColumnsList.push('Now');

            setResultColumnsList(myresultColumnsList);
            columnList = myresultColumnsList;
            setResultColumns(columns);
        }
    }

    function loadGuildsToGrid(guildsResult) {
        try {
            let guildRows = [];
            for (let i = 0; i < guildsResult.length; i++) {
                let guild = guildsResult[i];

                if (guild.members > 0) {
                    let colour = "transparent";
                    if (guild && guild.colour)
                        colour = convertHexToRGBA(guild.colour, 0.2);

                    let row = {
                        name:
                            <VuiBox display="flex" alignItems="center" bgColor={colour} sx={{ width: '100px', borderRadius: '12px' }}>
                                <VuiBox display="flex" alignItems="center" flexDirection="column" onClick={() => onSelectItem(null, guild.name)} sx={{ cursor: "pointer" }}>
                                    <VuiTypography pl="10px" variant="button" color="white" fontWeight="medium" >
                                        {guild.name}
                                    </VuiTypography>
                                    <VuiTypography pl="10px" variant="caption" color="text">
                                        {guild.ihid}
                                    </VuiTypography>
                                </VuiBox>
                            </VuiBox>
                    };

                    guildRows.push(row);
                }
            }

            setGuildRows(guildRows);
        }
        catch (error) {
            alert(error);
        }
    }

    function loadMembersToGrid(membersResult, guildsResult) {
        try {

            let members = [];
            let memberNames = [];
            for (let i = 0; i < membersResult.length; i++) {
                let member = membersResult[i];

                let guild = guildsResult.find(item => item.name === member.guild);

                let colour = "transparent";
                if (guild && guild.colour)
                    colour = convertHexToRGBA(guild.colour, 0.2);

                let guildname = 'Ex-Members';
                if (guild)
                    guildname = guild.name;

                let row = {
                    name:
                        <VuiBox display="flex" alignItems="center" px={0.8} py={0.1}>
                            <VuiBox display="flex" flexDirection="column" onClick={() => onSelectItem(member.name, guildname)} sx={{ cursor: "pointer" }}>
                                <VuiTypography variant="button" color="white" fontWeight="medium">
                                    {member.name}
                                </VuiTypography>
                            </VuiBox>
                        </VuiBox>,
                    guild:
                        <VuiBox display="flex" alignItems="center" bgColor={colour} sx={{ width: '100px', borderRadius: '12px' }}>
                            <VuiBox display="flex" alignItems="center" flexDirection="column">
                                <VuiTypography pl="10px" variant="button" color="white" fontWeight="medium" >
                                    {guildname}
                                </VuiTypography>
                            </VuiBox>
                        </VuiBox>,
                    actualname: member.name
                };

                memberNames.push(member.name);
                members.push(row);
            }

            setOriginalMemberRows(members);
            setMemberRows(members.slice(0, 50));
        }
        catch (error) {
            alert(error);
        }
    }

    const getDetails = useCallback(async () => {
        
        getUser()
            .then((result) => {
                getAPIToken()
                    .then((token) => {
                        getGuilds(token)
                            .then((guildsResult) => {
                                for (let i = 0; i < guildsResult.length; i++) 
                                    guildsResult[i].selected = false;

                                setGuilds(guildsResult);
                                allGuilds = guildsResult;
                                loadGuildsToGrid(guildsResult);
                                setResultsColumns(guildsResult);

                                getAllMembers(token)
                                    .then((membersResult) => {
                                        try {
                                            allMembers = membersResult;
                                            loadMembersToGrid(membersResult, guildsResult);
                                        }
                                        catch (error) {
                                            alert(error);
                                        }
                                    },
                                        (error) => {
                                            alert(error);
                                        });
                            },
                            (error) => {
                                alert(error);
                                });
                    },
                    (error) => {
                        alert(error);
                    });
            },
            (error) => {
                history.push('/authentication/sign-in');
            });
    }, []);


    useEffect(() => {
        getDetails();
    }, [getDetails]);

    return (
        <DashboardLayout>
            <DashboardNavbar />
            <VuiBox py={3}>
                <VuiBox mb={3}>
                    <Grid container spacing="18px">
                        <Grid item xs={12} lg={6} xl={6}>
                            <Card sx={{
                                height: '100%'
                            }}>
                                <VuiBox height="100%" display="flex" flexDirection="column" justifyContent="space-between">
                                    <VuiBox>
                                        <VuiBox display="flex" justifyContent="space-between" alignItems="center" mb="0px">
                                            <VuiTypography variant="lg" color="white">
                                                Members
                                            </VuiTypography>

                                            <VuiInput
                                                onChange={e => updateSearch(e.target.value)}
                                                placeholder="Search..."
                                                icon={{ component: "search", direction: "left" }}
                                                sx={({ breakpoints }) => ({
                                                    [breakpoints.down("sm")]: {
                                                        maxWidth: "80px",
                                                    },
                                                    [breakpoints.only("sm")]: {
                                                        maxWidth: "80px",
                                                    },
                                                    backgroundColor: "info.main !important",
                                                })}
                                            />
                                        </VuiBox>
                                        <VuiBox
                                            sx={{
                                                "& th": {
                                                    borderBottom: ({ borders: { borderWidth }, palette: { grey } }) =>
                                                        `${borderWidth[1]} solid ${grey[700]}`,
                                                },
                                                "& .MuiTableRow-root:not(:last-child)": {
                                                    "& td": {
                                                        borderBottom: ({
                                                            borders: { borderWidth }, palette: { grey } }) =>
                                                            `${borderWidth[1]} solid ${grey[700]}`,
                                                    },
                                                },
                                            }}
                                        >
                                            <TableFixed columns={memberColumns} rows={memberRows} />
                                        </VuiBox>
                                    </VuiBox>
                                </VuiBox>
                            </Card>
                        </Grid>

                        <Grid item xs={12} lg={6} xl={6}>
                            <Card sx={{
                                height: '100%'
                            }}>
                                <VuiBox height="100%" display="flex" flexDirection="column" justifyContent="space-between">
                                    <VuiBox>
                                        <VuiBox display="flex" justifyContent="space-between" alignItems="center" mb="0px">
                                            <VuiTypography variant="lg" color="white">
                                                Guilds
                                            </VuiTypography>
                                        </VuiBox>
                                        <VuiBox
                                            sx={{
                                                "& th": {
                                                    borderBottom: ({ borders: { borderWidth }, palette: { grey } }) =>
                                                        `${borderWidth[1]} solid ${grey[700]}`,
                                                },
                                                "& .MuiTableRow-root:not(:last-child)": {
                                                    "& td": {
                                                        borderBottom: ({
                                                            borders: { borderWidth }, palette: { grey } }) =>
                                                            `${borderWidth[1]} solid ${grey[700]}`,
                                                    },
                                                },
                                            }}
                                        >
                                            <TableFixed  columns={guildColumns} rows={guildRows} />
                                        </VuiBox>
                                    </VuiBox>
                                </VuiBox>
                            </Card>
                        </Grid>
                    </Grid>
                </VuiBox>
                <VuiBox mb={3}>
                    <Card sx={{
                        height: '100%'
                    }}>
                        <VuiBox height="100%" display="flex" flexDirection="column" justifyContent="space-between">
                            <VuiBox>
                                <VuiBox display="flex" justifyContent="space-between" alignItems="center" mb="0px">
                                    <VuiTypography variant="lg" color="white">
                                        Comparison by {sortMode}
                                    </VuiTypography>

                                    <VuiBox>
                                        <Icon sx={{ cursor: "pointer", color: "#ffffff" }} fontSize="small" onClick={openMenu}>
                                            show_chart
                                        </Icon>
                                        <Icon sx={{ cursor: "pointer", color: "#ffffff" }} fontSize="small" onClick={openMenu}>
                                            arrow_drop_down
                                        </Icon>
                                        {renderMenu}
                                    </VuiBox>
                                </VuiBox>
                                <VuiBox
                                    sx={{
                                        "& th": {
                                            borderBottom: ({ borders: { borderWidth }, palette: { grey } }) =>
                                                `${borderWidth[1]} solid ${grey[700]}`,
                                        },
                                        "& .MuiTableRow-root:not(:last-child)": {
                                            "& td": {
                                                borderBottom: ({
                                                    borders: { borderWidth }, palette: { grey } }) =>
                                                    `${borderWidth[1]} solid ${grey[700]}`,
                                            },
                                        },
                                    }}
                                >
                                    <TableFixed columns={resultColumns} rows={resultRows} />
                                </VuiBox>
                                <VuiBox sx={{ height: "510px" }}>
                                    <LineChart
                                        lineChartData={lineChartData}
                                        lineChartOptions={lineChartOptions}
                                    />
                                </VuiBox>
                            </VuiBox>
                        </VuiBox>
                    </Card>
                </VuiBox>
            </VuiBox>
            <Footer />
        </DashboardLayout>
    );
}

export default Compare;
